// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale, { scaleInverse } from "../helper/scaling";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  padding: 65px 0;
  @media (max-width: 700px) {
    padding: 26px 0;
  }
`;
const Inner = styled.div`
  width: 982px;
  padding: 24px calc(50% - 491px);
  font-family: Neuton;
  font-size: 34px;
  font-weight: 600;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.59;
  letter-spacing: 0.5px;
  text-align: center;
  color: #3949ab;
  position: relative;

  @media (max-width: 1100px) {
    width: ${scaleInverse(1100, 767, 118, 60, "vw")};
    padding: ${scale(1100, 767, 24, 20, "vw")} 0
      ${scale(1100, 767, 24, 20, "vw")} ${scale(1100, 767, 59, 30, "vw")};

    font-size: ${scale(1100, 767, 34, 26, "vw")};
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    margin: 0 23px;
    padding: 0;
    font-size: 16px;
  }
`;
const Image = styled.div`
  height: 100%;
  width: 100%;

  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;

  svg {
    height: 100%;
  }
`;

class StarFeature extends Component {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <Inner>
          <Image>
            <Star />
          </Image>
          {this.props.content.title}
        </Inner>
      </Wrapper>
    );
  }
}

export default StarFeature;

class Star extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="368"
        height="329"
        viewBox="0 0 368 329"
      >
        <path
          fill="#3949AB"
          fillRule="evenodd"
          d="M368 164.273c0 12.706-3.554 21.933-10.663 27.681-7.11 5.749-15.958 8.623-26.545 8.623-4.236 0-10.286-1.06-18.15-3.177-48.1-11.496-84.551-18.757-109.357-21.782 13.31 17.85 25.562 32.673 36.754 44.472 11.193 11.798 20.798 22.084 28.814 30.858 8.017 8.773 14.294 16.563 18.831 23.37 4.538 6.807 6.807 13.84 6.807 21.101 0 8.774-3.933 16.564-11.798 23.37-7.865 6.808-16.638 10.211-26.318 10.211-16.94 0-29.04-12.404-36.301-37.211-13.31-44.775-25.41-80.019-36.3-105.734-9.076 20.875-20.874 56.119-35.394 105.734C141.12 316.596 128.566 329 110.718 329c-8.773 0-17.168-3.328-25.184-9.983-8.017-6.656-12.025-14.522-12.025-23.598 0-7.26 2.269-14.294 6.807-21.101 4.537-6.807 10.89-14.597 19.058-23.37 8.167-8.774 17.847-19.06 29.04-30.858 11.193-11.799 23.445-26.623 36.755-44.472-24.806 3.025-61.106 10.286-108.903 21.782-8.167 2.118-14.52 3.177-19.058 3.177-10.587 0-19.436-2.874-26.545-8.623C3.554 186.206 0 176.98 0 164.274c0-11.195 3.554-19.817 10.663-25.867 7.11-6.05 15.958-9.076 26.545-9.076 4.538 0 10.89.908 19.058 2.723 51.73 11.798 88.03 18.908 108.903 21.328-13.31-17.547-25.562-32.295-36.755-44.245a14291.024 14291.024 0 0 1-29.04-31.085c-8.168-8.773-14.52-16.563-19.058-23.37-4.538-6.807-6.807-13.84-6.807-21.101 0-8.774 3.933-16.564 11.798-23.37C93.172 3.402 101.642 0 110.717 0c17.546 0 30.1 12.252 37.663 36.757 15.125 50.22 26.923 85.313 35.393 105.28 10.588-24.807 22.688-59.9 36.301-105.28C227.637 12.252 239.737 0 256.374 0c9.379 0 18.076 3.403 26.092 10.21 8.017 6.807 12.025 14.597 12.025 23.37 0 7.564-2.269 14.749-6.807 21.556-4.537 6.807-10.814 14.521-18.83 23.143a11709.769 11709.769 0 0 1-28.815 30.858c-11.192 11.95-23.444 26.698-36.754 44.245 17.545-2.118 44.468-7.11 80.77-14.975 27.528-6.05 43.107-9.076 46.737-9.076 10.587 0 19.436 3.025 26.545 9.076 7.109 6.05 10.663 14.672 10.663 25.866z"
          opacity=".05"
        />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StarFeature.js